import { CSSObject } from '@chakra-ui/react';

export const MatchesContainer: CSSObject = {
  px: '2',
  pb: '2',
  p: '2',
};
